import { useState } from 'react';
import ClickAwayListener from '@mui/material/ClickAwayListener'; 
import { flowRight } from 'lodash';
import ReferencesValueViewerProps from './ReferencesValueViewer.props';
import { StyledHtmlTooltip } from './ReferencesValueViewer.styles';
import { useDocumentFootnotes } from '../../../../context/DocumentFootnotesContext';
import withDialog from '../../../WithDialog';
import FastValueViewer from '../FastValueViewer';

const ReferencesValueViewer = (props: ReferencesValueViewerProps) => {
  const { mappingReferences } = props.cell as any;
  const { documentSourceMap } = useDocumentFootnotes();
  
  const [open, setOpen] = useState(false);

  const handleTooltipClose = () => {
    setOpen(false);
  };

  const handleTooltipToggle = (e: React.MouseEvent | React.KeyboardEvent) => {
    e.stopPropagation(); 
    setOpen((prevOpen) => !prevOpen);
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault(); 
      handleTooltipToggle(e);
    }
  };

  const tooltipContent =
    mappingReferences
      ?.map((ref: any) => {
        const cellRefs = ref.cell_references?.map((cr: any) => cr.ref).join(', ') || '';
        return `Source: ${documentSourceMap.get(ref.document_reference)} - Sheet: ${ref.sheet_name} - Cells: ${cellRefs}`;
      })
      .join('\n') || 'Mapped from source document';

  return (
    <ClickAwayListener onClickAway={handleTooltipClose}>
      <div>
        <StyledHtmlTooltip 
          title={tooltipContent} 
          placement="top" 
          arrow
          open={open}
          onClose={handleTooltipClose}
          disableHoverListener
          disableFocusListener
          disableTouchListener
        >
          {/* Added onMouseLeave to close when cursor exits the cell */}
          <div 
            onClick={handleTooltipToggle} 
            onKeyDown={handleKeyDown}
            onMouseLeave={handleTooltipClose}
            role="button"
            tabIndex={0}
            style={{ cursor: 'pointer' }}
          >
            <FastValueViewer {...props} />
          </div>
        </StyledHtmlTooltip>
      </div>
    </ClickAwayListener>
  );
};

const enhancements = flowRight(withDialog);
export default enhancements(ReferencesValueViewer);
